import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';

import { Tab, Tabs, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';

import edit from "../../../assets/images/edit.png";
import AssetsIcon from '../../../assets/images/oparation.svg';
import AssetsIconw from '../../../assets/images/oparation_a.svg';

import Export from './Components/RecordExport';
import Import from './Components/RecordImport';

const ShipmentRecords = () => {
    const keysToRemove = ['Ftab_inbound', 'Ftab_planning', 'Ftab_export', 'Ftab_import'];
    keysToRemove.forEach(key => {
        localStorage.removeItem(key);
    });
    const initialTab = localStorage.getItem("Ftab_shprec") || 'import';
    const [selectedButton, setSelectedButton] = useState(initialTab);
    useEffect(() => {
        setSelectedButton(initialTab);
    }, [initialTab]);
    // console.log('555', selectedButton);
    const handleButtonClick = (button) => {
        setSelectedButton(button);
        localStorage.setItem('Ftab_shprec', button);
    };


    return (
        <div className="">
            <Header page_type='fsm' logo_url='/ForwarderShipments/ShipmentRecords' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <TopMenu module='FSHPMNGR' />
                        <div className="">
                            <div className="allcontent-fl">
                                <div className='d-flex justify-content-between mb-3'>
                                    <div>
                                        <button className={selectedButton === 'export' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('export')}>
                                            <img src={selectedButton === 'export' ? AssetsIconw : AssetsIcon}/> <span>Export</span>
                                        </button>
                                        <button className={selectedButton === 'import' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('import')}>
                                            <img src={selectedButton === 'import' ? AssetsIconw : AssetsIcon} /> <span>Import</span>
                                        </button>
                                    </div>
                                    <div className='search'>
                                        <div className="form-group has-search">

                                            {/* <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                /> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="lcontent">
                                    {selectedButton === 'export' && <Export />}
                                    {selectedButton === 'import' && <Import />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ShipmentRecords;